import styled from 'styled-components'

import type { FC } from 'react'

type Props = {
  alt?: string
  src?: string
}

export const ContentImage: FC<Props> = ({ src, alt }) => {
  return <Image alt={alt} src={src} />
}

const Image = styled.img<{ aspectRatio?: string }>`
  display: block;
  object-fit: cover;
  object-position: center;
  border-radius: 1rem;
  margin-bottom: 1rem;
`
